import Backdrop from "../Dialog/Backdrop";
import styles from "./ChangeImage.module.css";
import cross from "../../../images/Popup/Cross.svg";
import { useState, useRef } from "react";
import { FaCloudUploadAlt, FaFileImport } from "react-icons/fa";
import { pdfToImg } from "pdftoimg-js/browser";
import { API } from "../../../config";

export const ChangeImageDialog = (props) => {
  const [loading, setLoading] = useState({
    pdf: false,
    link: false,
  });
  const [images, setImages] = useState([]);
  const [link, setLink] = useState("");
  const fileInputRef = useRef(null);
  const imageInputRef = useRef(null);

  const handlePDFImport = () => {
    fileInputRef.current.click();
  };

  const handleImageUpload = () => {
    imageInputRef.current.click();
  };

  const handleImageClick = (image) => {
    props.handleSave(image);
  };

  const handleImageSelected = (e) => {
    const file = e.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onload = () => {
        handleImageClick(reader.result);
      };
      reader.readAsDataURL(file);
    }
    e.target.value = "";
  };

  const handleGetImagesFromLink = async () => {
    setLoading((p) => ({ ...p, link: true }));
    const response = await fetch(`${API}/catalogs/images/url`, {
      method: "POST",
      body: JSON.stringify({
        url: link,
      }),
    });
    const json = await response.json();
    setImages((p) => {
      if (!p) return json.images;
      return [...json.images, ...p];
    });
    setLoading((p) => ({ ...p, link: false }));
  };

  const convertPdfToImages = async (file) => {
    setLoading((p) => ({ ...p, pdf: true }));
    const url = URL.createObjectURL(file);
    const images = await pdfToImg(url, {
      imgType: "png",
      pages: "all",
      scaleForBrowserSupport: true,
    });
    setImages((p) => {
      if (!p) return images;
      return [...images, ...p];
    });
    URL.revokeObjectURL(url);
    setLoading((p) => ({ ...p, pdf: false }));
  };

  const handlePDFSelected = (e) => {
    const file = e.target.files[0];
    if (file) {
      convertPdfToImages(file);
    }
  };

  return props.show ? (
    <div>
      <Backdrop show={props.show} switch={props.switch} />
      <div className={styles.popup}>
        <div className={styles.cross}>
          <img src={cross} alt="" onClick={props.switch} />
        </div>

        <div className={styles.title} style={{ alignSelf: "start" }}>
          Select Image
        </div>

        <div style={{ marginTop: "20px", width: "100%" }}>
          <div
            style={{
              display: "flex",
              gap: 6,
              alignItems: "center",
              width: "100%",
            }}
          >
            <input
              key="image-url"
              type="url"
              className={styles.linkInput}
              placeholder="Enter Amazon URL of the Product"
              value={link}
              onChange={(e) => setLink(e.target.value)}
            />
            <button
              className={styles.button}
              disabled={loading.link || !link || link.trim() === ""}
              onClick={handleGetImagesFromLink}
            >
              {loading.link ? "Fetching..." : "Get Images"}
            </button>
          </div>
        </div>

        <button
          className={styles.button}
          style={{ width: "100%" }}
          disabled={loading.pdf || loading.link}
          onClick={handleImageUpload}
        >
          <FaCloudUploadAlt />
          Upload Image Manually
        </button>

        <button
          onClick={handlePDFImport}
          className={styles.button}
          style={{ width: "100%" }}
          disabled={loading.pdf}
        >
          <FaFileImport />
          {loading.pdf ? "Importing..." : "Import from PDF"}
        </button>

        <input
          ref={fileInputRef}
          type="file"
          accept="application/pdf"
          style={{ display: "none" }}
          onChange={handlePDFSelected}
        />

        <input
          ref={imageInputRef}
          type="file"
          accept="image/*"
          style={{ display: "none" }}
          onChange={handleImageSelected}
        />

        {images.length > 0 && (
          <div
            style={{
              flexGrow: 1,
              width: "100%",
              marginTop: "20px",
              display: "grid",
              gridTemplateColumns: "repeat(3, 1fr)",
              gap: "10px",
              overflowY: "auto",
              overflowX: "hidden",
            }}
          >
            {images.map((img, idx) => (
              <img
                key={idx}
                src={img}
                alt={`pdf-img-${idx}`}
                onClick={() => handleImageClick(img)}
                style={{
                  width: "100%",
                  height: "160px",
                  objectFit: "cover",
                  borderRadius: "6px",
                  border: "1px solid #ddd",
                }}
              />
            ))}
          </div>
        )}
      </div>
    </div>
  ) : null;
};
